import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="page about-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <span className="page-badge">About Us</span>
            <h1>Your Trusted Guide to UK Casinos</h1>
            <p>Helping British players find safe, licensed, and enjoyable online casinos since 2020</p>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-main">
              <h2>Who We Are</h2>
              <p>
                SlotsHub UK is an independent affiliate website dedicated to helping UK players navigate 
                the world of online gambling. Our team of experienced reviewers, former casino professionals, 
                and gambling enthusiasts work together to provide honest, comprehensive casino reviews and 
                recommendations.
              </p>
              <p>
                We understand that choosing an online casino can be overwhelming. With hundreds of options 
                available to UK players, it's hard to know which sites are trustworthy, offer fair bonuses, 
                and provide a genuinely enjoyable gaming experience. That's where we come in.
              </p>

              <h2>Our Mission</h2>
              <p>
                Our mission is simple: to help UK players make informed decisions about where to play online. 
                We achieve this by:
              </p>
              <ul className="feature-list">
                <li>Conducting thorough, unbiased reviews of every casino we feature</li>
                <li>Verifying licensing and regulatory compliance with the UK Gambling Commission</li>
                <li>Testing games, bonuses, and customer service first-hand</li>
                <li>Promoting responsible gambling and player safety</li>
                <li>Keeping our information accurate and up-to-date</li>
              </ul>

              <h2>How We Work</h2>
              <p>
                As an affiliate website, we earn commission when players sign up to casinos through our links. 
                However, this commercial relationship never influences our reviews. We evaluate every casino 
                using the same rigorous criteria, and we only recommend sites that we would feel comfortable 
                playing at ourselves.
              </p>
              <p>
                Our editorial and commercial teams operate independently. The casinos featured on our site 
                are selected based on quality, not on the commission rates they offer. If a casino doesn't 
                meet our standards, it won't appear on SlotsHub UK – regardless of how much they're willing 
                to pay.
              </p>

              <h2>Our Team</h2>
              <p>
                Our team brings together diverse expertise from across the gambling industry. We have former 
                casino managers who understand how operators work, gaming mathematicians who can analyse bonus 
                terms and game RTPs, and customer service specialists who know what good support looks like.
              </p>
              <p>
                Most importantly, we're all passionate players ourselves. We know the excitement of hitting 
                a big win, the frustration of unclear bonus terms, and the importance of being able to 
                withdraw your winnings quickly and easily.
              </p>

              <h2>Our Commitment to Responsible Gambling</h2>
              <p>
                We take responsible gambling seriously. While we want to help players find great casinos 
                and exciting bonuses, we always encourage responsible play. Gambling should be entertaining, 
                never a way to make money or escape problems.
              </p>
              <p>
                Every page on our site includes links to responsible gambling resources. If you or someone 
                you know is struggling with gambling, please seek help from organisations like BeGambleAware 
                or GamCare.
              </p>

              <div className="cta-box">
                <h3>Questions?</h3>
                <p>We'd love to hear from you. Get in touch with our team for any enquiries.</p>
                <Link to="/contact" className="btn btn-primary">Contact Us</Link>
              </div>
            </div>

            <aside className="content-sidebar">
              <div className="sidebar-card">
                <h4>Quick Facts</h4>
                <ul className="facts-list">
                  <li>
                    <span className="fact-label">Founded</span>
                    <span className="fact-value">2020</span>
                  </li>
                  <li>
                    <span className="fact-label">Casinos Reviewed</span>
                    <span className="fact-value">50+</span>
                  </li>
                  <li>
                    <span className="fact-label">Team Members</span>
                    <span className="fact-value">8</span>
                  </li>
                  <li>
                    <span className="fact-label">Location</span>
                    <span className="fact-value">United Kingdom</span>
                  </li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h4>Our Values</h4>
                <ul className="values-list">
                  <li>
                    <strong>Honesty</strong>
                    <p>Unbiased reviews you can trust</p>
                  </li>
                  <li>
                    <strong>Safety</strong>
                    <p>Only licensed, regulated casinos</p>
                  </li>
                  <li>
                    <strong>Responsibility</strong>
                    <p>Promoting safe gambling practices</p>
                  </li>
                  <li>
                    <strong>Expertise</strong>
                    <p>Industry professionals on our team</p>
                  </li>
                </ul>
              </div>

              <div className="sidebar-card highlight">
                <h4>Need Help?</h4>
                <p>If you're concerned about gambling, support is available 24/7.</p>
                <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-block">
                  GambleAware.org
                </a>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
